// ✅ Secure reCAPTCHA-only bot protection (ES5-safe, production hardened)
(function () {
  'use strict';

window.loadGTM = function () {
  if (window.gtmAlreadyLoaded) return;
  window.gtmAlreadyLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'vdg_verification_passed' });

  (function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),
        dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-5MC7T9SW');
};


  var config = {
    siteKey: '6LfMduQqAAAAAEhBnxmS9tVQqKfakHeOj_3ptG12',
    verifyEndpoint: 'https://api.padronn.com/api/verify-recaptcha',
    threshold: 0.8,
    trustedIps: ['91.140.27.123', '116.203.76.94'],
    watchdogTimeout: 15000
  };




  var state = {
    verified: false,
    riskScore: 0,
    visitorId: null,
    token: null
  };

  window.vdgVerified = false;
  window.vdgWhitelisted = false;
  window.vdgRiskScore = 0;

  var isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
  if (isMobile) config.watchdogTimeout = 20000;

  function blockOverlay(reason) {
    var overlay = document.createElement('div');
    overlay.id = 'security-block-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:999999;background:#fffbe6;text-align:center;padding-top:10%;font-family:sans-serif;color:#333;';
    overlay.innerHTML =
      '<h2>🔐 Access Blocked</h2>' +
      '<p>Security verification failed.</p>' +
      '<p><strong>Reason:</strong> ' + reason + '</p>' +
      '<button id="retry-btn" style="margin-top:20px;padding:10px 20px;font-size:16px;background:#000;color:#fff;border:none;border-radius:6px;cursor:pointer;">🔁 Try Again</button>';
    document.body.appendChild(overlay);
    setTimeout(function () {
      var btn = document.getElementById('retry-btn');
      if (btn) btn.addEventListener('click', function () {
        location.reload(true);
      });
    }, 100);
  }

  function watchdog() {
    setTimeout(function () {
      if (!state.verified && !state.token) {
        console.warn('[⏱️ Watchdog timeout]');
        blockOverlay('Timeout: No token received');
      }
    }, config.watchdogTimeout);
  }

  function getFingerprint(cb) {
    loadScript('https://cdn.jsdelivr.net/npm/@fingerprintjs/fingerprintjs@3/dist/fp.min.js', {}, function () {
      if (!window.FingerprintJS) return cb();
      FingerprintJS.load().then(function (fp) {
        fp.get().then(function (res) {
          state.visitorId = res.visitorId;
          console.log('[🧬 visitorId]', state.visitorId);
          cb();
        }).catch(function (err) {
          console.warn('[⚠️ Fingerprint error]', err);
          cb();
        });
      });
    });
  }

  function loadScript(src, attrs, cb) {
    var s = document.createElement('script');
    s.src = src;
    if (attrs) for (var k in attrs) s.setAttribute(k, attrs[k]);
    s.onload = cb;
    s.onerror = function () {
      console.warn('[⚠️ Script failed]', src);
      cb();
    };
    document.head.appendChild(s);
  }

  function waitForRecaptcha(cb) {
    var waited = 0;
    var max = 10000;
    (function check() {
      if (window.grecaptcha && grecaptcha.enterprise && typeof grecaptcha.enterprise.execute === 'function') {
        console.log('[✅ reCAPTCHA ready]');
        cb();
      } else if (waited >= max) {
        blockOverlay('reCAPTCHA not ready');
      } else {
        waited += 200;
        setTimeout(check, 200);
      }
    })();
  }

  function verify() {
    console.log('[🔒 reCAPTCHA execute]');
    grecaptcha.enterprise.execute(config.siteKey, { action: 'page_view' }).then(function (token) {
      console.log('[🎟️ Token received]');
      state.token = token;
      var xhr = new XMLHttpRequest();
      xhr.open('POST', config.verifyEndpoint, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          try {
            var json = JSON.parse(xhr.responseText);
            console.log('[🛡️ Verification result]', json);

            var isWhitelisted = json.whitelisted === true || json.whitelisted === "true";
            var riskScore = typeof json.riskScore === 'number' ? json.riskScore : 0;

            window.vdgWhitelisted = isWhitelisted;
            window.vdgRiskScore = riskScore;

            if (json.blocked) return blockOverlay('Blocked by server');
            if (!json || (!isWhitelisted && riskScore < config.threshold)) {
              return blockOverlay('Low score (' + riskScore + ')');
            }

            state.verified = true;
            window.vdgVerified = true;
            window.dispatchEvent(new CustomEvent('vdg-verified'));

            if (typeof window.loadGTM === 'function') {
  console.log('[🚀 Calling loadGTM from copy.js]');
  window.loadGTM();
} else {
  console.warn('[❌ loadGTM not defined yet]');
}


            var blockedPatterns = ['facebook', 'fbevents', 'fbq'];
            document.querySelectorAll('script[src]').forEach(function (s) {
              for (var i = 0; i < blockedPatterns.length; i++) {
                if (s.src.includes(blockedPatterns[i])) {
                  console.warn('[🛑 Tracking blocked]', s.src);
                  s.remove();
                  break;
                }
              }
            });

            // ✅ Patch createElement
            var isGtmDebug = /[?&](gtm_debug|gtm_preview|gtm_auth)=/.test(location.href);
            var allowAlways = [
              'googletagmanager.com/gtm.js?id=GTM-5MC7T9SW',
              'googletagmanager.com/debug/bootstrap',
              'googletagmanager.com/gtag/js?id=GT-'
            ];
            var originalCreate = document.createElement;
            document.createElement = function (tag) {
              if (tag === 'script') {
                var el = originalCreate.call(document, tag);
                var setAttr = el.setAttribute;
                el.setAttribute = function (name, value) {
                  if (name === 'src') {
                    if (
                      isGtmDebug ||
                      allowAlways.some(function (p) { return value.includes(p); }) ||
                      (window.vdgVerified && window.vdgRiskScore >= config.threshold)
                    ) {
                      console.log('[✅ Allowed script]', value);
                      return setAttr.call(this, name, value);
                    } else if (blockedPatterns.some(function (p) { return value.includes(p); })) {
                      console.warn('[⛔ Script blocked]', value);
                      return;
                    }
                  }
                  return setAttr.call(this, name, value);
                };
                return el;
              }
              return originalCreate.call(document, tag);
            };

            sessionStorage.setItem('verified', '1');
            sessionStorage.setItem('riskScore', riskScore.toString());
            localStorage.setItem('vdg_fingerprint', state.visitorId);
            document.cookie = "vdg_verified=1; path=/; max-age=3600; samesite=lax";

          } catch (e) {
            console.warn('[❌ JSON parse error]', e);
            blockOverlay('Response parse error');
          }
        }
      };
      xhr.send(JSON.stringify({
        token: token,
        visitorId: state.visitorId,
        action: 'page_view',
        ts: Date.now()
      }));
    }).catch(function () {
      console.warn('[❌ reCAPTCHA exec error]');
      blockOverlay('reCAPTCHA failed');
    });
  }

  function initSecurity() {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.designMode === true) {
        console.log('[🛠️ Theme Editor – Bypassed]');
        return;
      }
    } catch (e) {}

    getFingerprint(function () {
      loadScript('https://www.google.com/recaptcha/enterprise.js?render=' + config.siteKey, {}, function () {
        waitForRecaptcha(function () {
          watchdog();
          verify();
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSecurity);
  } else {
    setTimeout(initSecurity, 0);
  }

})();

setTimeout(() => {
  const found = [...document.querySelectorAll('script')].some(s => s.src.includes('gtm.js'));
  if (!found) {
    console.warn('[⛔ GTM NOT LOADED]');
    console.log('vdgVerified:', window.vdgVerified);
    console.log('vdgWhitelisted:', window.vdgWhitelisted);
    console.log('vdgRiskScore:', window.vdgRiskScore);
  } else {
    console.log('[✅ GTM script present]');
  }
}, 8000); // 🔁 αυξάνουμε σε 8s


